import { createFileRoute } from '@tanstack/react-router';

import { OrgProfilePage } from '@/features/profiles/org-profile-page';

/** The supplier's public profile page (`/c/{slug}`), managed like any company's. */
export const Route = createFileRoute('/_app/supplier/$orgId/public')({
  component: SupplierPublicRoute,
});

function SupplierPublicRoute() {
  const { orgId } = Route.useParams();
  return <OrgProfilePage orgId={orgId} />;
}
